/* Explanation prose, plus the numbered flow when the step has one. */
import { useTranslation } from 'react-i18next';
import type { Block } from '../../types';

export function Prose({ block }: { block: Block }) {
  const { t } = useTranslation();

  const paragraphs = block.bodyKey ? (t(block.bodyKey, { returnObjects: true }) as string[]) : [];
  const flow = block.flowKey ? (t(block.flowKey, { returnObjects: true }) as string[]) : [];

  return (
    <>
      {paragraphs.map((paragraph, i) => (
        <p key={i} className="prose">
          {paragraph}
        </p>
      ))}

      {flow.length > 0 && (
        <div className="card-flat">
          <p className="eyebrow" style={{ marginBottom: 6 }}>
            {t('flowTitle')}
          </p>
          <ol className="flowlist">
            {flow.map((step, i) => (
              <li key={i}>
                <span className="fn num">{('0' + (i + 1)).slice(-2)}</span>
                <span>{step}</span>
              </li>
            ))}
          </ol>
        </div>
      )}
    </>
  );
}
